import HiringQuery from 'apps/hiring/util/query';
import { resolve } from 'library/helpers/path-resolver';
import { jsonToInputParams } from 'library/util/graph';

const PossibleMatch = (match) => {
  if (resolve(match, 'params/target', false)) {
    return `match(target_id:${Number(resolve(match, 'params/target', null))}),`;
  }
  return '';
};

const applicantsQuery = (params = {}) => {
  const applicationSortParams = jsonToInputParams({
    sort_by: params.sort_by,
    sort_order: params.sort_order,
    surveyed: resolve(params, 'surveyed', true),
    limit: resolve(params, 'limit', 15),
    status: resolve(params, 'status', 'Applied')
  });
  return HiringQuery(`
  {
    organization {
      id
    }
    opening (id: ${params.match.params.id}) {
      name,
      closed,
      applications(${applicationSortParams}) {
        pagination {
          total,
          limit,
          offset
        }
        results {
          id,
          status,
          resume_url,
          ${PossibleMatch(params.match)}
          user {
            first_name,
            last_name,
            id,
            email
          }
          assessment (completed: true) {
            id
            validity_score,
            validity_errors,
            scored
          }
        }
      }
    }
  }`
  );
};

const applicantsParseQuery = (data) => ({
  applications: resolve(data, 'opening/applications/results', []),
  users: {
    pagination: resolve(data, 'opening/applications/pagination', {total:0}),
    results: resolve(data, 'opening/applications/results', []).map(r=>({
      date_applied: resolve(r, 'created_at', ''),
      name: resolve(r, 'user/name', ''),
      opening: resolve(r, 'opening', {}),
      resume: resolve(r, 'resume_url', ''),
      survey_status: resolve(r, 'survey/status', 'Pending'),
      view: `/hiring/openings/${resolve(r, 'opening/id')}/applicants/${resolve(r, 'id')}`
    }))
  }
});

export { applicantsQuery, applicantsParseQuery };
